import React from 'react'

const ArrowDown = ({ fill = '#00587E' }) => {
    return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.9722 8.2928C19.3627 8.68332 19.3627 9.31649 18.9722 9.70701L12.9722 15.707C12.5816 16.0975 11.9485 16.0975 11.558 15.707L5.55795 9.70701C5.16743 9.31649 5.16743 8.68332 5.55795 8.2928C5.94848 7.90228 6.58164 7.90228 6.97217 8.2928L12.2651 13.5857L17.558 8.2928C17.9485 7.90228 18.5816 7.90228 18.9722 8.2928Z"
                fill={fill}
            />
        </svg>
    )
}

export default ArrowDown
